import {useEffect, useRef, useState} from "react";

import TeacherConstant from "../../utils/constants/TeacherConstant";
import Days from "../../utils/constants/Days";

import EmptyCell from "./EmptyCell";
import LessonCell from "./LessonCell";

import {getDateString} from "../../utils/Utils";

let TimeTable = (props) => {
    let mainTable = useRef();

    let [gridChanged, setGridChanged] = useState(false)
    let [columnCount, setColumnCount] = useState(0)

    useEffect(() => {
        if (mainTable) {
            if (props.currentTeacher !== TeacherConstant.ID_SELECT_ALL) {
                mainTable.current.style["grid-template-columns"] = "repeat(7, minmax(120px, 1fr))";
                return;
            }
            let res = "";
            let columns = 0;
            for (let day in props.dailyTable) {
                let teacherIds = props.dailyTable[day];
                let len = teacherIds.length === 0 ? 1 : teacherIds.length;
                columns += len;
                let columnFr = (1 / len).toFixed(2);
                let minPx = Math.floor(120 * columnFr)
                res += "repeat(" + len + ", minmax(" + minPx + "px," + columnFr + "fr))";
            }
            mainTable.current.style["grid-template-columns"] = res
            setColumnCount(columns);
        }
        setGridChanged(true);
    }, [props.currentTeacher, props.location, props.dailyTable])

    let isInBannedTimes = (dateString, hour, teacherid) => {
        if (props.bannedTimes === null)
            return false;
        for (let banned of props.bannedTimes) {
            let bannedTime = getDateString(new Date(banned.date))
            if (bannedTime === dateString && hour === banned.hour && banned.teacherid === teacherid)
                return true
        }
        return false;
    }
    let getTeacherNameById = (teacherid) => {
        let ret = "";
        let teacher = props.data.teachers[teacherid];
        ret += TeacherConstant.major_symbol[teacher.major] + teacher.name
        return ret;
    }
    let getTeacherNames = () => {
        let res = [];
        if (props.currentTeacher === TeacherConstant.ID_SELECT_ALL) {
            let num = 0;
            for (let day in props.dailyTable) {
                let teacherIds = props.dailyTable[day];
                if (teacherIds.length !== 0) {
                    for (let teacherId in teacherIds) {
                        let teacherName = getTeacherNameById(teacherIds[teacherId]);
                        let key = teacherName + num;
                        num += 1;
                        res.push(<div className="table-main-cell table-cell-teachername" key={key}>
                            <p className="table-cell-teachername-text">
                                {teacherName}
                            </p>
                        </div>)
                    }
                } else {
                    res.push(<div className="table-cell-lesson-empty" key={"empty-num" + num}></div>)
                    num += 1;
                }
            }
        } else {
            let num = 0;
            let table = typeof props.table[props.currentTeacher] === "undefined" ? [] : props.table[props.currentTeacher].times
            let days = Days.keyset_render;

            for (let day of days) {
                if (typeof table[day] === "undefined" || table[day].length === 0) {
                    res.push(<div className="table-cell-lesson-empty" key={"empty-num" + num}></div>)
                } else {
                    let teacherName = getTeacherNameById(props.currentTeacher);
                    let key = teacherName + num
                    res.push(<div className="table-main-cell table-cell-teachername" key={key}>
                        <p className="table-cell-teachername-text">
                            {teacherName}
                        </p>
                    </div>)
                }
                num += 1;
            }
        }
        return res;
    }
    let getDayIndex = (due) => {
        let dueDate = new Date(due);
        let dayGap = dueDate.getDay() - props.startDate.getDay();
        if (dayGap === -1) {
            dayGap = dayGap = 6;
        }
        return dayGap;
    }
    let getDayString = (due) => {
        let dueDate = new Date(due);
        return Days.keyset[dueDate.getDay()]
    }
    let getHourIndex = (hour) => {
        return Days.timeset.indexOf(hour);
    }

    let getLessonTables = () => {
        let ret = [];
        if (props.currentTeacher === TeacherConstant.ID_SELECT_ALL) {
            for (let i = 0; i < Days.timeset.length * columnCount; i++) {
                let hourIndex = Math.floor(i / columnCount)
                let hour = Days.timeset[hourIndex];

                let verticalIndex = i - columnCount * hourIndex;

                let teacherIndexOffset = 0;
                let dayIndex = 0;

                let j = 0;
                // eslint-disable-next-line
                for (let dayString in props.dailyTable) {
                    let sum = 0;
                    for (let k = 0; k < j; k++) {
                        let len = props.dailyTable[Days.keyset_render[k]].length
                        if (len === 0) {
                            sum += 1
                        } else sum += len
                    }
                    if (verticalIndex >= sum) {
                        teacherIndexOffset = sum;
                        dayIndex = j;
                    }
                    j += 1;
                }
                let teacherIndex = verticalIndex - teacherIndexOffset;
                let dayString = Days.keyset_render[dayIndex];

                let teacherid = props.dailyTable[dayString][teacherIndex];
                let isBanned = Days.timeset_banned.includes(hour);

                if (typeof teacherid === "undefined" || props.table[teacherid].times[dayString].indexOf(hour) === -1)
                    isBanned = true;

                let emptyDue = new Date(props.startDate);
                emptyDue.setDate(emptyDue.getDate() + dayIndex);
                let dateString = getDateString(emptyDue)

                isBanned ||= isInBannedTimes(dateString, hour, teacherid)

                ret.push(<EmptyCell key={"empty" + i} isBanned={isBanned} dateString={dateString}
                                    dueDate={emptyDue} teacherid={teacherid} hour={hour} data={props.data}
                                    location={props.location} needUpdate={props.needUpdate}
                                    myInformation={props.myInformation} setNeedInfoRefresh={props.setNeedInfoRefresh}
                                    setNeedUpdate={props.setNeedUpdate} isAdmin={props.isAdmin}>
                </EmptyCell>);
            }

            for (let lesson of props.lessons) {
                let verticalIndexOffset = getHourIndex(lesson.hour) * columnCount;

                let sum = 0;
                for (let dayKeysetIndex in Days.keyset_render) {
                    let dayString = Days.keyset_render[dayKeysetIndex]
                    if (dayString === getDayString(lesson.due))
                        break;
                    sum += props.dailyTable[dayString].length === 0 ? 1 : props.dailyTable[dayString].length;
                }

                let dailyIndexOffset = sum + verticalIndexOffset;
                let teacherid = lesson.teacherid;
                let teacherIndex = props.dailyTable[getDayString(lesson.due)].indexOf(teacherid)

                let lessonDueDate = new Date(lesson.due);
                let newDateObject = new Date(props.startDate)
                newDateObject.setDate(props.startDate.getDate() + 6);

                if(getDateString(lessonDueDate) < getDateString(props.startDate) || getDateString(lessonDueDate) > getDateString(newDateObject))
                    continue;

                if (teacherIndex === -1)
                    continue;

                let index = dailyIndexOffset + teacherIndex;

                ret[index] = (<LessonCell data={props.data} lesson={lesson}
                                          key={index} needUpdate={props.needUpdate}
                                          setNeedUpdate={props.setNeedUpdate} isAdmin={props.isAdmin}
                                          myInformation={props.myInformation}
                                          setNeedInfoRefresh={props.setNeedInfoRefresh}
                ></LessonCell>)
            }
        } else {
            for (let i = 0; i < Days.timeset.length * Days.keyset.length; i++) {
                let hourIndex = Math.floor(i / Days.keyset.length)
                let hour = Days.timeset[hourIndex];
                let day = i - Days.keyset.length * hourIndex;
                let dayString = Days.keyset_render[day];

                let isAvailable = typeof props.table[props.currentTeacher] !== "undefined" &&
                    typeof props.table[props.currentTeacher].times[dayString] !== "undefined" &&
                    props.table[props.currentTeacher].times[dayString].indexOf(hour) !== -1;

                let isBanned = Days.timeset_banned.includes(hour) || !isAvailable

                let verticalIndex = i - Days.keyset.length * hourIndex;
                let emptyDue = new Date(props.startDate);

                emptyDue.setDate(emptyDue.getDate() + verticalIndex);

                let dateString = getDateString(emptyDue);
                isBanned ||= isInBannedTimes(dateString, hour, props.currentTeacher)

                ret.push(<EmptyCell key={"empty" + i} isBanned={isBanned} dateString={dateString}
                                    dueDate={emptyDue} teacherid={props.currentTeacher} hour={hour}
                                    location={props.location} needUpdate={props.needUpdate}
                                    setNeedUpdate={props.setNeedUpdate} data={props.data}
                                    isAdmin={props.isAdmin} myInformation={props.myInformation}
                                    setNeedInfoRefresh={props.setNeedInfoRefresh}
                >
                </EmptyCell>);
            }
            for (let lesson of props.lessons) {
                let index = getDayIndex(lesson.due) + Days.keyset.length * getHourIndex(lesson.hour);

                let lessonDueDate = new Date(lesson.due);
                let newDateObject = new Date(props.startDate)
                newDateObject.setDate(props.startDate.getDate() + 6);

                if(getDateString(lessonDueDate) < getDateString(props.startDate) || getDateString(lessonDueDate) > getDateString(newDateObject))
                    continue;
                if (lesson.teacherid === parseInt(props.currentTeacher))
                    ret[index] = (<LessonCell data={props.data} lesson={lesson}
                                              key={index} needUpdate={props.needUpdate}
                                              setNeedUpdate={props.setNeedUpdate}
                                              isAdmin={props.isAdmin} myInformation={props.myInformation}
                                              setNeedInfoRefresh={props.setNeedInfoRefresh}
                    ></LessonCell>)
            }

        }
        return ret;
    }
    return (
        <div className="table-main" ref={mainTable}>
            {gridChanged ? getTeacherNames() : null}
            {getLessonTables()}
        </div>
    );
}
export default TimeTable;
